import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FillModal } from "../../../../components";
import TopArea from "../../../../components/TopArea";
import { useMobile } from "../../../../context/MobileContext";
import { useModal } from "../../../../context/ModalContext";
import { useApiData } from "../../context/ApiDataContext";
import { useGetPreferProject } from "../../hooks/index.hook";
import Advantages from "../Advantages";
import CompanyProfile from "../CompanyProfile";
import FAQ from "../FAQ";
import Introduction from "../Introduction";
import Marquee from "../Marquee";
import Partners from "../Partners";
import PreferredProject from "../PreferredProject";
import Steps from "../Steps";
import Transaction from "../Transaction";
import styles from "./style.module.scss";

const HomeContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openSignInUp } = useModal();
  const { profile, popupData, data } = useApiData();
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const { isMobile } = useMobile();

  const { data: preferProjectData } = useGetPreferProject();

  const sectionEnum = [
    {
      id: "steps",
      title: t("home.steps"),
      subTitle: null,
      content: <Steps />,
      showMore: false,
      clickMore: () => {},
    },
    {
      id: "prefer-project",
      title: t("home.perfer.project"),
      subTitle: t("home.perfer.project.subTitle"),
      content: isMobile ? (
        // <PreferredProjectSwiper data={preferProjectData} />
        <PreferredProject data={preferProjectData} />
      ) : (
        <PreferredProject data={preferProjectData} />
      ),
      showMore: true,
      clickMore: () => navigate("/project"),
    },
    {
      id: "company-profile",
      title: t("home.company.profile"),
      subTitle: profile?.title,
      content: <CompanyProfile />,
      showMore: false,
      clickMore: () => {},
    },
    {
      id: "introduction",
      title: t("home.introduction"),
      subTitle: t("home.introduction.subtitle"),
      content: <Introduction />,
      showMore: false,
      clickMore: () => {},
    },
    // {
    //   id: "team",
    //   title: t("home.team"),
    //   subTitle: t("home.team.subtitle"),
    //   content: <Team />,
    //   showMore: false,
    //   clickMore: () => {},
    // },
    {
      id: "advantages",
      title: t("home.advantages"),
      subTitle: t("home.advantages.subtitle"),
      content: <Advantages />,
      showMore: false,
      clickMore: () => {},
    },
    {
      id: "faq",
      title: t("home.faq"),
      subTitle: null,
      content: <FAQ />,
      showMore: false,
      clickMore: () => {},
    },
    {
      id: "transaction",
      title: t("home.transaction"),
      subTitle: null,
      content: <Transaction />,
      showMore: false,
      clickMore: () => {},
    },
    // {
    //   id: "methods",
    //   title: t("home.methods"),
    //   subTitle: t("home.methods.subtitle"),
    //   content: <Methods />,
    //   showMore: false,
    //   clickMore: () => {},
    // },
    {
      id: "partners",
      title: t("home.partners"),
      subTitle: null,
      content: <Partners />,
      showMore: false,
      clickMore: () => {},
    },
  ];

  const renderSection = (section, index) => {
    return (
      <div className={styles.component} key={index} id={section.id}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>{section.title}</div>
          {section.showMore && (
            <div className={styles.more} onClick={section.clickMore}>
              {t("normal.more")}
            </div>
          )}
        </div>
        {section.subTitle && <div className={styles.subTitle}>{section.subTitle}</div>}
        {section.content}
      </div>
    );
  };

  // useEffect(() => {
  //   if (!isLogin) openSignInUpModal(signInUpEnum.SIGN_IN);
  // }, [isLogin]);

  useEffect(() => {
    if (!popupData || openSignInUp) return;
    setOpenModal(true);
    setModalData({ title: popupData.title, isHtml: true, content: popupData.content });
  }, [popupData, openSignInUp]);

  return (
    <div className={`${styles.home} home`} id="home">
      <div className={styles.marqueeArea}>
        <iframe
          title="tradingView"
          src={`https://www.tradingview-widget.com/embed-widget/ticker-tape/?locale=en&random=${Math.random()}#%7B"symbols"%3A%5B%7B"proName"%3A"BITSTAMP%3ABTCUSD"%2C"title"%3A"Bitcoin"%7D%2C%7B"proName"%3A"BITSTAMP%3AETHUSD"%2C"title"%3A"Ethereum"%7D%2C%7B"proName"%3A"BITSTAMP%3ADOGEUSD"%2C"title"%3A"Dogecoin"%7D%2C%7B"proName"%3A"BITSTAMP%3ALTCUSD"%2C"title"%3A"Litecoin"%7D%2C%7B"proName"%3A"BITSTAMP%3ABCHUSD"%2C"title"%3A"Bitcoin%20Cash"%7D%2C%7B"proName"%3A"BITSTAMP%3AADAUSD"%2C"title"%3A"Cardano"%7D%2C%7B"proName"%3A"BITSTAMP%3AXRPUSD"%2C"title"%3A"XRP"%7D%5D%2C"showSymbolLogo"%3Atrue%2C"colorTheme"%3A"normal"%2C"isTransparent"%3Afalse%2C"displayMode"%3A"adaptive"%2C"width"%3A"100%25"%2C"height"%3A78%2C"utm_source"%3A"globalecrypto.com"%2C"utm_medium"%3A"widget_new"%2C"utm_campaign"%3A"ticker-tape"%2C"page-uri"%3A"ljmining.com%2F"%7D`}
          seamless="seamless"
          frameBorder="0"
          className={`${styles.iframe} iframe`}
        />
        <Marquee />
      </div>
      <div className={styles.container}>
        <TopArea data={data} />
        {/* <Menu /> */}
        {sectionEnum.map((section, index) => {
          return renderSection(section, index);
        })}
      </div>
      <FillModal open={openModal} setOpen={setOpenModal} data={modalData} />
    </div>
  );
};

export default HomeContainer;
